export const EXCEL_MIME_TYPES = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const DOCX_MIME_TYPES = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
export const DOC_MIME_TYPES = 'application/msword'
export const PDF_MIME_TYPES = 'application/pdf'
export const PNG_MIME_TYPES = 'image/png'
